<template>
  <div class="campus-recruiting-search">
    <form class="search-input flex-start" action="javascript:void 0">
      <span class="iconfont iconsearch"/>
      <input v-model="comp_name" type="text" @keyup.13="searchList" placeholder="搜索职位或公司" ref="inputText" growing-track='true'>
      <div @click="toBack">取消</div>
    </form>
    <div class="jobs-container">
      <cube-scroll ref="scroll" :data="compRecruitInfos" :options="options" @pulling-down="onPullingDown"
                   @pulling-up="onPullingUp">
        <job-list-campus :list-data="compRecruitInfos" @toDetail="toDetail" @collection="collection"/>
        <w-more-loading v-show="moreLoading"/>
        <w-no-more v-show="isEnd && !noResultShow"/>
      </cube-scroll>
    </div>
    <no-result v-if="noResultShow" no-result-title="很抱歉，没有找到相关内容"
               img-src="https://files.wondercv.com/mobile_no_result@2x.png"/>
    <w-loading v-show="searchLoading"/>
  </div>
</template>

<script>
	import WLoading from '../../components/global/w-loading'
	import WMoreLoading from '../../components/global/w-more-loading'
	import WNoMore from '../../components/global/w-no-more'
	import jobListCampus from '../job-components/job-list-campus'
	import noResult from '../job-components/no-result'
	import { campusMixin } from '../../assets/js/mixin/jobs'
	import { envMixin, loginMixin } from '../../assets/js/mixin/global'
	import { componentsMixin } from '../../assets/js/mixin/components'

	export default {
		name: 'campus-search',
		mixins: [ campusMixin, envMixin, loginMixin, componentsMixin ],
		data () {
			return {
				comp_name: '',
				searchLoading: false,
				moreLoading: false,
				noResultShow: false,
				compRecruitInfos: [],
				isEnd: false,
				page: 1,
				options: {
					pullDownRefresh: false,
					pullUpLoad: true
				}
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.refreshPageData(from.name)
			})
		},
		mounted () {
		},
		computed: {},
		watch: {},
		components: {
			WLoading,
			WMoreLoading,
			WNoMore,
			jobListCampus,
			noResult,
		},
		methods: {
			onPullingUp () {
				if (!this.isEnd) {
					this.page += 1
					this.loadingShow = true
					this._getCampusList()
				} else {
					this.$refs.scroll.forceUpdate()
				}
			},
			onPullingDown () {
				this.page = 1
				this._getCampusList(true)
			},
			// 刷新列表数据
			refreshPageData (name) {
				if (name !== 'campus-detail') {
					this.comp_name = ''
					this.noResultShow = false
					this.isEnd = false
					this.page = 1
					this.compRecruitInfos = []
				}
			},
			// 搜索点击事件
			searchList () {
				this.searchLoading = true
				this.noResultShow = false
				this.isEnd = false
				this.page = 1
				this._getCampusList(true)
				this.$refs.inputText.blur()
			},
			// 返回事件
			toBack () {
				this.$router.back()
			},
			// 获取校招列表数据
			async _getCampusList (refresh) {
				let res = await this.$api.jobs.getCompRecruitList({
					comp_name: this.comp_name,
					page: this.page
				})
				if (refresh) {
					this.compRecruitInfos = res.data.comp_recruit_infos
				} else {
					this.compRecruitInfos = [ ...this.compRecruitInfos, ...res.data.comp_recruit_infos ]
				}
				this.moreLoading = true
				this.searchLoading = false
				if (this.compRecruitInfos.length >= res.data.total_count) {
        	this.isEnd = true
        }
				if (!this.compRecruitInfos.length) this.noResultShow = true
				if (this.isEnd) {
					this.moreLoading = false
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/global/variable';
  @import '@/assets/scss/global/mixin';
  .campus-recruiting-search {
    height: 100vh;
    background-color: #f8f8fa;
    .search-input {
      position: relative;
      padding: 0 16px;
      height: 44px;
      font-size: $font-size-medium-x;
      color: $color-title;
      .iconsearch {
        position: absolute;
        left: 30px;
        font-weight: bold;
        color: $color-light-gray;
      }
      input {
        width: 85%;
        height: 32px;
        border-radius: 16px;
        background-color: #f2f2f2;
        margin-right: 11px;
        padding-left: 35px;
        font-size: $font-size-medium;
        border: none !important;
      }
      div {
        flex: 1;
        height: 16px;
      }
    }
    .jobs-container {
      height: calc(100vh - 44px);
    }
  }
</style>
